import * as types from './types';
import i18n from 'src/translation/i18n';

const setRegion = (region: string) => {
  return { type: types.SET_REGION, payload: region };
};

const setLanguage = (language: string) => {
  return { type: types.SET_LANGUAGE, payload: language };
};

const setCurrency = (currency: string) => {
  return { type: types.SET_CURRENCY, payload: currency };
};

const changeLanguage = (lang: string) => (dispatch: any) => {
  i18n.changeLanguage(lang, () => {
    localStorage.setItem('i18nextLng', lang);
  });
  dispatch(setLanguage(lang));
};

export default {
  setRegion,
  setLanguage,
  setCurrency,
  changeLanguage
};
